import { CourseMaterial } from "./coursesLoader.ts";
import useVirtualStore from "../../common/virtual-store/useVirtualStore.tsx";
import { useMiniPdpContext } from "../../common/product/mini-pdp/miniPdpContext.ts";

export default function useStudentChoice(material: CourseMaterial) {
  const { isVirtualStore } = useVirtualStore();
  const miniPdpContext = useMiniPdpContext();
  const isOutOfStock = miniPdpContext?.isOutOfStock;
  const isUnavailable = miniPdpContext?.isUnavailable;
  const isMinPDPActive =
    isVirtualStore &&
    material.buttonLinks.find((link) => link.type === "ePOS") &&
    !isOutOfStock &&
    !isUnavailable;
  return {
    isMinPDPActive,
    isMaterialOutOfStock: isOutOfStock,
    isMaterialUnavailable: isUnavailable,
  };
}
